<template>
  <div class="mt-3">
    <h2 class="fw-bold">
      <router-link to="/embeds" class="text-teal" title="Links Externos">
        Links Externos
      </router-link>
      <span class="text-gray">/ Power BI</span>
    </h2>
  </div>
  <LoadingData v-if="loadData" />
  <div v-else class="card border-start border-start-width-3 border-start-teal">
    <div v-html="iframe" />
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'

export default {
  name: 'PowerBI',

  components: {
    LoadingData,
  },

  data() {
    return {
      iframe: '',
      loadData: false,
    }
  },

  methods: {
    async getEmbeds() {
      try {
        this.loadData = true
        const response = await this.$store.dispatch('getEmbeds')

        const embed = response.find((item) => item.nome === 'Power BI')
        this.iframe = embed.link

        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getEmbeds()
  },
}
</script>
